import type {LinksFunction, MetaFunction} from '@remix-run/node'
import {useRouteLoaderData} from '@remix-run/react'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {getDomainConfig} from '~/domains'
import {AboutPageEnhanced, teamImageDesktopUrl, teamImageMobileUrl} from './AboutPageEnhanced'
import {AboutPageLegacy} from './AboutPageLegacy'

export const meta: MetaFunction = ({matches}) => {
  const rootData = matches.find((match) => match.id === 'root')?.data as RootLoaderResponse | undefined
  const language = rootData?.language ?? 'en-US'
  const translations = getTranslation(language)

  return [
    {
      title: translations.AboutPageMeta.title,
    },
    {
      name: 'description',
      content: translations.AboutPageMeta.description,
    },
  ]
}

export const links: LinksFunction = () => [
  {
    rel: 'preload',
    href: '/fonts/about/playfair-display-latin-wght-normal.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous',
  },
  {
    rel: 'preload',
    href: '/fonts/about/playball-latin-400-normal.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous',
  },
  {
    rel: 'preload',
    href: teamImageDesktopUrl,
    as: 'image',
    type: 'image/webp',
    media: '(min-width: 768px)',
    fetchpriority: 'high',
  },
  {
    rel: 'preload',
    href: teamImageMobileUrl,
    as: 'image',
    type: 'image/webp',
    media: '(max-width: 767px)',
    fetchpriority: 'high',
  },
  {rel: 'stylesheet', href: '/fonts/about/about-fonts.css'},
]

export default function AboutUS() {
  const {hostname, language, locale, domain, featureFlags} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {siteName, styles: domainStyles} = getDomainConfig(domain, locale)
  const contactEmail = `contact@${hostname?.replace(/^www\./, '')}`

  const showEnhancedAboutPage = featureFlags?.displayEnhancedAboutPage || featureFlags?.showImprovedHomepage
  return showEnhancedAboutPage ? (
    <AboutPageEnhanced translations={translations} domainStyles={domainStyles} contactEmail={contactEmail} />
  ) : (
    <AboutPageLegacy translations={translations} siteName={siteName} contactEmail={contactEmail} hostname={hostname} />
  )
}
